
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { UiTextbox } from '../keen-ui'
import InputErrors from '../shared/input-errors.component.vue'
import InputLabel from '../shared/input-label.component.vue'

export default defineComponent({
  name: 'NumberServiceConfigField',
  components: {
    UiTextbox,
    InputLabel,
    InputErrors,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    value: {
      type: Number,
    },
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    errors: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      baseClass: 'epb-number-service-config-field',
    }
  },
  methods: {
    input(value: string): void {
      let numberValue = Number(value)
      if (isNaN(numberValue)) {
        numberValue = undefined
      }
      this.$emit('input', numberValue)
    },
  },
})
